import { Entity } from 'dexie';
import { hasBadgeIdentification } from '../../utils/driver-identification';
import { getFormatE164, getFormatNational } from '../../utils/normalize-phone';
import type { AppDB } from '../db';

class Driver extends Entity<AppDB> {
  public uid!: number;
  public uid_service!: number;
  public lastname: string;
  public firstname: string;
  public pnd: boolean;
  public phone_number: string;
  public identification: string;
  public keywords: string;
  public email_address: string | null;

  public get lastnameFull(): string | null {
    return this.lastname.trim() === '' ? null : this.lastname;
  }

  public get firstnameFull(): string | null {
    return this.firstname.trim() === '' ? null : this.firstname;
  }

  public get label() {
    if (this.firstnameFull && this.lastnameFull) {
      return `${this.firstnameFull} ${this.lastnameFull}`;
    }
    return this.firstnameFull || this.lastnameFull || '';
  }

  public get phone(): string | null {
    return getFormatNational(this.phone_number);
  }

  public get phoneE164() {
    return getFormatE164(this.phone_number);
  }

  public get keywordList() {
    return this.keywords ? this.keywords.split(',').map(Number) : null;
  }

  public get uid_parent(): number {
    return this.uid_service;
  }

  /**
   * Whether the driver carries a usable identification: the four-digit code typed on the device for
   * a PND driver, the badge number otherwise. An off-format value counts as none at all.
   */
  public get hasBadge(): boolean {
    return hasBadgeIdentification(this.identification, this.pnd);
  }

  public get email(): typeof this.email_address {
    return this.email_address;
  }
}

export default Driver;
